<template lang="pug">
.c-progress-form__element
  label.c-progress-form__title(v-html="$t('profiles.questions.salary_category')")
  p.c-progress-form__description(v-html="$t('profiles.questions.salary_disclaimer')")
  .c-multiple-choice
    .row.c-multiple-choice__options
      .column.c-multiple-choice__item(v-for="category in availableCategories")
        input.c-multiple-choice__radio(type="radio" :value="category" name="salary" :id="category" v-model="salaryCategory")
        label.c-multiple-choice__label(:for="category") {{$t(`profiles.questions.salary_categories.${category}`)}}
</template>

<script>
export default {
  data () {
    return {
      availableCategories: [
        'cat1',
        'cat2',
        'cat3',
        'cat4',
        'cat5',
        'cat0'
      ]
    }
  },
  computed: {
    salaryCategory: {
      get () {
        return this.$store.state.person.salary_category
      },
      set (value) {
        this.$store.commit('updatePersonInfo', {name: 'salary_category', value: value})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/profiles/Salary.vue